import { useMutation, useQuery } from '@tanstack/react-query'

import { ResidentParkingSpotMinified, ResidentVehicle } from '@/models'

import { authAPI } from '../new-api'

export interface GetResidentVehiclesRequest {
  residentId: number
}

export interface GetResidentVehiclesResponse {
  parkings: ResidentParkingSpotMinified[]
  vehicles: ResidentVehicle[]
}

export const GET_RESIDENT_VEHICLES_BASE_QUERY_KEY = 'useGetResidentVehicles'

export const getResidentVehiclesQueryKey = (data: GetResidentVehiclesRequest) => [
  GET_RESIDENT_VEHICLES_BASE_QUERY_KEY,
  data,
]

export const getResidentVehicles = async (
  data: GetResidentVehiclesRequest,
): Promise<GetResidentVehiclesResponse> => {
  const response = await authAPI.get<GetResidentVehiclesResponse>(`/parking/client-vehicles`, {
    params: {
      clientId: data.residentId,
    },
  })

  return response.data
}

export const useGetResidentVehicles = (data: GetResidentVehiclesRequest) => {
  return useQuery({
    queryFn: () => getResidentVehicles(data),
    queryKey: getResidentVehiclesQueryKey(data),
  })
}

export const useFetchResidentVehicles = () => {
  return useMutation({
    mutationFn: getResidentVehicles,
  })
}
